<template>
    <Breadcrumbs :list="breadcrumpsList"/>
    <pv-confirm-dialog></pv-confirm-dialog>
    <div class="main-card mb-3 card">
        <div class="card-body">


            <pv-table
                    ref="dt"
                    :value="rows"
                    :lazy="false"
                    :totalRecords="totalRecords"
                    :paginator="true"
                    :rows="20"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[20,50, 100]"
                    currentPageReportTemplate="{first} - {last} z {totalRecords}"
                    responsiveLayout="scroll"
                    :loading="loading"
                    v-model:filters="filters"
                    filterDisplay="row"


            >


                <pv-column field="action.name" header="Nazwa akcji" style="width: auto">
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="action.dateFrom" header="Od" style="width: 150px">
                    <template #body="{data}">
                        {{formatDate(data.action.dateFrom)}}
                    </template>
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="action.dateTo" header="Do" style="width: 150px">
                    <template #body="{data}">
                        {{formatDate(data.action.dateTo)}}
                    </template>
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="soldTarget" header="Cel sprzedażowy 1" style="width: 110px;  text-align: center;" />
                <pv-column field="secondTarget" header="Cel sprzedażowy 2" style="width: 110px;  text-align: center;" />
                <pv-column field="thirdTarget" header="Cel sprzedażowy 3" style="width: 110px;  text-align: center;" />
                <pv-column field="contactTarget" header="Cel kontaktowy" style="width: 100px;  text-align: center;" />
                <pv-column field="promotionDays" header="Cel promo dni" style="width: 100px;  text-align: center;" />


                <pv-column  style="width: 170px">
                    <template #body="{data}">
                        <pv-button icon="fa fa-store" class="p-button-rounded p-button-primary me-2" @click="shopList(data)" />
                        <pv-button icon="fa fa-trophy" class="p-button-rounded p-button-primary me-2" @click="targetList(data)" />
                    </template>
                </pv-column>
            </pv-table>

        </div>
    </div>
</template>

<script>

    import Breadcrumbs from '@miro-labs/vue3-architect-layout/layout/base/Breadcrumbs.vue'
    import Button from 'primevue/button'
    import DateTable from 'primevue/datatable'
    import Column from 'primevue/column'
    import InputText from 'primevue/inputtext'
    import ConfirmDialog from 'primevue/confirmdialog';
    import {FilterMatchMode} from 'primevue/api';



    export default {
        setup() {
            const breadcrumpsList = [
                {label: "Strona główna", routerName: 'mainPage', params: {}, query: {}},
                {label: "Supervisor", routerName: 'svActionList', params: {}, query: {}},
                {label: "Akcje"}
            ];
            return {
                breadcrumpsList
            }
        },


        components: {
            Breadcrumbs,
            'pv-button': Button,
            'pv-table': DateTable,
            'pv-column': Column,
            'pv-input-text': InputText,
            'pv-confirm-dialog': ConfirmDialog,
        },




        data() {
            return {
                loading: false,
                rows: [],
                totalRecords: 0,
                enableAction: true,
                importing: false,
                filters: {
                    'action.name': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'action.dateFrom': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'action.dateTo': {value: '', matchMode: FilterMatchMode.CONTAINS},
                },

                lazyParams: {},
                selectedRows: [],
            }
        },


        methods: {


            shopList(item) {
                this.$router.replace({name: 'svActionPlans', params: {id: item.action.id}});
            },

            targetList(item) {
                this.$router.replace({name: 'svActionTargets', params: {id: item.id}});
            },

            formatDate(value) {
                let date = new Date(value);
                return date.toLocaleDateString('pl-Pl', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                });
            },



            async refreshTable() {
                this.rows = await this.$store.dispatch('sv/findActions');
                this.totalRecords = this.rows.length;

                this.loading = false;
            },



        },

        mounted() {
            this.loading = true;

            this.refreshTable();
        },

    }
</script>